import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import RecipientMailtipMessageRow from './RecipientMailtipMessageRow';

export interface CustomMailtipProps {
    recipientsInfo: CustomMailtipRecipientInfo[];
}

export interface CustomMailtipRecipientInfo {
    recipient: EmailAddressWrapper;
    customMessage: JSX.Element;
}

const CustomMailtip = (props: CustomMailtipProps) => {
    return (
        <div>
            {props.recipientsInfo.map(recipientInfo => (
                <div key={recipientInfo.recipient.EmailAddress}>
                    <RecipientMailtipMessageRow
                        recipient={recipientInfo.recipient}
                        recipientMessage={recipientInfo.customMessage}
                    />
                </div>
            ))}
        </div>
    );
};

export default CustomMailtip;
